import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import CommonBits from './CommonBits';
import CoordinateFilter from '../geom/CoordinateFilter';
import Coordinate from '../geom/Coordinate';
import CoordinateSequenceFilter from '../geom/CoordinateSequenceFilter';
var CommonBitsRemover = /*#__PURE__*/function () {
  function CommonBitsRemover() {
    _classCallCheck(this, CommonBitsRemover);
    CommonBitsRemover.constructor_.apply(this, arguments);
  }
  _createClass(CommonBitsRemover, [{
    key: "addCommonBits",
    value: function addCommonBits(geom) {
      var trans = new Translater(this._commonCoord);
      geom.apply(trans);
      geom.geometryChanged();
    }
  }, {
    key: "removeCommonBits",
    value: function removeCommonBits(geom) {
      if (this._commonCoord.x === 0.0 && this._commonCoord.y === 0.0) return geom;
      var invCoord = new Coordinate(this._commonCoord);
      invCoord.x = -invCoord.x;
      invCoord.y = -invCoord.y;
      var trans = new Translater(invCoord);
      geom.apply(trans);
      geom.geometryChanged();
      return geom;
    }
  }, {
    key: "getCommonCoordinate",
    value: function getCommonCoordinate() {
      return this._commonCoord;
    }
  }, {
    key: "add",
    value: function add(geom) {
      geom.apply(this._ccFilter);
      this._commonCoord = this._ccFilter.getCommonCoordinate();
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._commonCoord = null;
      this._ccFilter = new CommonCoordinateFilter();
    }
  }]);
  return CommonBitsRemover;
}();
export { CommonBitsRemover as default };
var CommonCoordinateFilter = /*#__PURE__*/function () {
  function CommonCoordinateFilter() {
    _classCallCheck(this, CommonCoordinateFilter);
    CommonCoordinateFilter.constructor_.apply(this, arguments);
  }
  _createClass(CommonCoordinateFilter, [{
    key: "filter",
    value: function filter(coord) {
      this._commonBitsX.add(coord.x);
      this._commonBitsY.add(coord.y);
    }
  }, {
    key: "getCommonCoordinate",
    value: function getCommonCoordinate() {
      return new Coordinate(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [CoordinateFilter];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._commonBitsX = new CommonBits();
      this._commonBitsY = new CommonBits();
    }
  }]);
  return CommonCoordinateFilter;
}();
var Translater = /*#__PURE__*/function () {
  function Translater() {
    _classCallCheck(this, Translater);
    Translater.constructor_.apply(this, arguments);
  }
  _createClass(Translater, [{
    key: "filter",
    value: function filter(seq, i) {
      var xp = seq.getOrdinate(i, 0) + this.trans.x;
      var yp = seq.getOrdinate(i, 1) + this.trans.y;
      seq.setOrdinate(i, 0, xp);
      seq.setOrdinate(i, 1, yp);
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return false;
    }
  }, {
    key: "isGeometryChanged",
    value: function isGeometryChanged() {
      return true;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [CoordinateSequenceFilter];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.trans = null;
      var trans = arguments[0];
      this.trans = trans;
    }
  }]);
  return Translater;
}();
CommonBitsRemover.CommonCoordinateFilter = CommonCoordinateFilter;
CommonBitsRemover.Translater = Translater;